import _ from 'underscore';
import { CustomParametersView } from '@bingads-webui-campaign/upgrade-url';

import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');

export default class extends CustomParametersView {
  initialize(options = {}) {
    let opt = _.defaults({}, options, {
      customParameters: _.clone(options.observable()),
      permissions: config.get('Permissions') || {},
      i18n,
    });

    options.observable.validate = () => {
      let ret = true;

      _.each(this.viewModel.parameters(), (param) => {
        ret = ret && param.isValid();
      });

      return ret && _.isEmpty(this.viewModel.errorMessages());
    };

    super.initialize(opt);

    this.viewModel.parameterArray.subscribe((val) => {
      let newVal = _.filter(val, (item) => {
        return !_.isEmpty(item.Key);
      });

      options.observable(newVal);
    });
  }
}
